import React, { useState, useEffect } from "react";
import { Route } from "react-router-dom";

export const CollegeRoute = () => {
  const [collegeData, setCollegeData] = useState([]);
  function fetchData() {
    fetch("/data.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setCollegeData(data.colleges);
      })
      .catch((e) => console.log("Error reading data", e.message));
  }
  useEffect(() => {
    fetchData();
    return () => {
      // eslint-disable-next-line
    };
  }, []);
  return (
    <React.Fragment>
      {collegeData.map((college) => (
        <Route
          path={`/college-website/${college.website}`}
          render={() => (window.location = `${college.website}`)}
        />
      ))}
    </React.Fragment>
  );
};
